export default function Related() {
  return (
    <div>
      <p>Related</p>
    </div>
  );
}
